// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "b56ae7bc4db5a3fe0ca2213bb4f24c96048aba72/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};